module.exports = __webpack_public_path__ + "img/sand-art-base.e4d0ca68.jpg";